module.exports = __webpack_public_path__ + "static/media/books_on_a_shelf.45a7192b.svg";